import { Box, Typography } from "@outschool/backpack";
import * as FilestackUrls from "@outschool/filestack-urls";
import { FeaturedTeacherCard_LeaderFragment } from "@outschool/gql-frontend-generated";
import { leaderPath } from "@outschool/routes";
import { useImpressionTracking } from "@outschool/ui-legacy-component-library";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

export default function FeaturedTeacherCard({
  leader,
}: {
  leader: FeaturedTeacherCard_LeaderFragment;
}) {
  const path = leaderPath(leader.uid, leader.leader_link);
  const imageUrl = FilestackUrls.imageUrl(leader.photo, {
    w: 300,
    h: 300,
    fit: "crop",
  });
  const Link = useLinkComponent();
  const [trackingNode, setTrackingNode] = React.useState(null);
  const { trackTouch } = useImpressionTracking({
    node: trackingNode,
    trackingLabel: "feature_teacher_card",
    uniqueId: leader.uid,
    sharedProperties: { leader_uid: leader.uid },
  });
  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "1em",
        border: "1px solid",
        borderColor: "grey.100",
        textAlign: "left",
      }}
      ref={setTrackingNode}
    >
      <Link to={path} onClick={() => trackTouch()}>
        <Box
          sx={{
            backgroundImage: `url("${imageUrl}")`,
            paddingBottom: "100%",
            backgroundSize: "cover",
            width: "100%",
            borderRadius: "16px 16px 0 0",
          }}
        />
        <Box
          flex
          sx={{
            flexDirection: "column",
            gap: "0.5em",
            padding: "1em",
          }}
        >
          <Box
            sx={{
              color: "grey.900",
              fontWeight: "fontWeightBold",
              overflowWrap: "anywhere",
            }}
          >
            {leader.name}
          </Box>
          <Box>
            <Typography
              variant="inherit"
              sx={{
                color: "grey.500",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: "2px",
                maxHeight: "3.2em",
                overflowWrap: "anywhere",
              }}
            >
              {leader.details.headlineTranslated}
            </Typography>
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
